/* Meyer Modehaus – Brand JS: Größenassistent, Swatch-Sync, Bewertungs-Medien */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. Farb-Swatch: Label „Farbe — Wert“ aktuell halten
     ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-mm-swatch-input]')) return;
    var wrap = el.closest('[data-mm-swatches]');
    if (!wrap) return;
    var pos = wrap.getAttribute('data-option-position');
    var target = document.querySelector('[data-mm-color-value="' + pos + '"]');
    if (target) target.textContent = el.value;
  });

  /* ------------------------------------------------------------------
     2. Größenassistent
     ------------------------------------------------------------------ */
  var W_STEPS_F = [
    { max: 48, size: 34 }, { max: 54, size: 36 }, { max: 60, size: 38 },
    { max: 67, size: 40 }, { max: 74, size: 42 }, { max: 82, size: 44 },
    { max: 90, size: 46 }, { max: 99, size: 48 }, { max: 108, size: 50 },
    { max: 999, size: 52 }
  ];
  var W_STEPS_M = [
    { max: 60, size: 44 }, { max: 66, size: 46 }, { max: 72, size: 48 },
    { max: 79, size: 50 }, { max: 86, size: 52 }, { max: 94, size: 54 },
    { max: 103, size: 56 }, { max: 112, size: 58 }, { max: 999, size: 60 }
  ];
  var LETTERS = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL'];
  var MAP_F = { 30: 'XXS', 32: 'XXS', 34: 'XS', 36: 'S', 38: 'M', 40: 'M', 42: 'L', 44: 'L', 46: 'XL', 48: 'XL', 50: 'XXL', 52: 'XXL', 54: '3XL', 56: '3XL' };
  var MAP_M = { 42: 'XS', 44: 'XS', 46: 'XS', 48: 'S', 50: 'M', 52: 'L', 54: 'XL', 56: 'XXL', 58: '3XL', 60: '4XL', 62: '4XL' };

  function baseSize(gender, kg) {
    var table = gender === 'herren' ? W_STEPS_M : W_STEPS_F;
    for (var i = 0; i < table.length; i++) if (kg <= table[i].max) return table[i].size;
    return table[table.length - 1].size;
  }

  function deToLetter(gender, de) {
    var map = gender === 'herren' ? MAP_M : MAP_F;
    if (map[de]) return map[de];
    var keys = Object.keys(map).map(Number).sort(function (a, b) { return a - b; });
    var best = keys[0];
    for (var i = 0; i < keys.length; i++) {
      if (Math.abs(keys[i] - de) < Math.abs(best - de)) best = keys[i];
    }
    return map[best];
  }

  function normalise(v) {
    return String(v || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function firstNumber(v) {
    var m = String(v).match(/\d{2,3}/);
    return m ? parseInt(m[0], 10) : NaN;
  }

  function matchAvailable(values, gender, de) {
    var letter = deToLetter(gender, de);
    var numeric = [];
    var i, n;

    for (i = 0; i < values.length; i++) {
      n = firstNumber(values[i]);
      if (!isNaN(n) && n >= 28 && n <= 74) numeric.push({ raw: values[i], n: n });
    }
    if (numeric.length) {
      numeric.sort(function (a, b) { return Math.abs(a.n - de) - Math.abs(b.n - de); });
      return numeric[0].raw;
    }

    for (i = 0; i < values.length; i++) {
      if (normalise(values[i]) === letter) return values[i];
    }
    var target = LETTERS.indexOf(letter), best = null, bestD = 99;
    for (i = 0; i < values.length; i++) {
      var idx = LETTERS.indexOf(normalise(values[i]));
      if (idx === -1) continue;
      var d = Math.abs(idx - target);
      if (d < bestD) { bestD = d; best = values[i]; }
    }
    return best;
  }

  function initAdvisor(root) {
    if (!root || root.__mmInit) return;
    root.__mmInit = true;

    var gender = root.getAttribute('data-gender') || 'damen';
    var steps = root.querySelectorAll('.mm-sa__step');
    var dots = root.querySelectorAll('.mm-sa__dot');
    var answers = { fit: 0, shape: 0, usual: null, h: 0, w: 0 };
    var current = 0;

    function show(i) {
      current = i;
      for (var s = 0; s < steps.length; s++) steps[s].classList.toggle('is-active', s === i);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d <= i);
    }

    function next() {
      if (current === 0) {
        var h = parseFloat(root.querySelector('[data-mm-height]').value);
        var w = parseFloat(root.querySelector('[data-mm-weight]').value);
        var err = root.querySelector('.mm-sa__error');
        if (!h || !w || h < 130 || h > 215 || w < 35 || w > 200) {
          err.classList.add('is-on');
          return;
        }
        err.classList.remove('is-on');
        answers.h = h; answers.w = w;
        show(1);
        return;
      }
      if (current < steps.length - 1) show(current + 1);
    }

    function compute() {
      var sel = root.querySelector('[data-mm-usual]');
      if (sel && sel.value) answers.usual = parseFloat(sel.value);

      var de = baseSize(gender, answers.w);
      if (answers.h >= 178) de -= 2;
      else if (answers.h <= 160) de += 2;
      de += (answers.fit || 0) * 2;
      de += (answers.shape || 0) * 2;
      if (answers.usual) de = (de + answers.usual * 2 * 2) / 3;
      de = Math.round(de / 2) * 2;

      var min = gender === 'herren' ? 44 : 32;
      var max = gender === 'herren' ? 62 : 56;
      if (de < min) de = min;
      if (de > max) de = max;

      var values = [];
      var inputs = document.querySelectorAll('[data-mm-size-option] [data-variant-input]');
      for (var i = 0; i < inputs.length; i++) values.push(inputs[i].value);

      var pick = values.length ? matchAvailable(values, gender, de) : null;
      var display = pick || String(de);

      root.querySelector('[data-mm-result-size]').textContent = display;
      root.querySelector('[data-mm-result-alt]').textContent = deToLetter(gender, de);
      show(steps.length - 1);

      if (pick) {
        for (var k = 0; k < inputs.length; k++) {
          if (inputs[k].value === pick) {
            inputs[k].checked = true;
            inputs[k].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
        var pop = document.querySelector('[data-mm-size-pop]');
        if (pop) {
          pop.querySelector('[data-mm-size-pop-value]').textContent = pick;
          pop.classList.add('is-on');
        }
      }
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.mm-sa__opt');
      if (opt) {
        var group = opt.getAttribute('data-group');
        var sibs = root.querySelectorAll('.mm-sa__opt[data-group="' + group + '"]');
        for (var s = 0; s < sibs.length; s++) sibs[s].classList.remove('is-selected');
        opt.classList.add('is-selected');
        answers[group] = parseFloat(opt.getAttribute('data-value'));
        setTimeout(function () { if (current < steps.length - 2) show(current + 1); }, 160);
        return;
      }
      if (e.target.closest('[data-mm-sa-calc]')) { compute(); return; }
      if (e.target.closest('[data-mm-sa-next]')) { next(); return; }
      if (e.target.closest('[data-mm-sa-back]')) { if (current > 0) show(current - 1); return; }
      if (e.target.closest('[data-mm-sa-restart]')) { show(0); return; }
    });

    show(0);
  }

  /* ------------------------------------------------------------------
     3. Modal-Steuerung
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var open = e.target.closest ? e.target.closest('[data-mm-open]') : null;
    if (open) {
      e.preventDefault();
      var m = document.getElementById(open.getAttribute('data-mm-open'));
      if (m) {
        m.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        initAdvisor(m.querySelector('[data-mm-advisor]'));
      }
      return;
    }
    if ((e.target.closest && e.target.closest('[data-mm-close]')) || (e.target.classList && e.target.classList.contains('mm-modal'))) {
      var open2 = document.querySelector('.mm-modal.is-open');
      if (open2) { open2.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
      return;
    }
    if (e.target.closest && e.target.closest('.mm-sa-pop__close')) {
      e.target.closest('.mm-sa-pop').classList.remove('is-on');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = document.querySelector('.mm-modal.is-open');
      if (m) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
    }
  });

  /* ------------------------------------------------------------------
     4. Express-Checkout-Buttons entfernen
     ------------------------------------------------------------------ */
  function stripExpress() {
    var sel = '.additional-checkout-buttons, .dynamic-checkout__content, [data-shopify-buttoncontainer], .shopify-payment-button';
    var nodes = document.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) nodes[i].remove();
  }
  document.addEventListener('DOMContentLoaded', stripExpress);
  document.addEventListener('shopify:section:load', stripExpress);
  setTimeout(stripExpress, 1200);
  setTimeout(stripExpress, 3000);

  /* ------------------------------------------------------------------
     5. Bewertungs-Videos bei Sichtbarkeit starten
     ------------------------------------------------------------------ */
  function observeVideos() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var v = entries[i].target;
        if (entries[i].isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      }
    }, { threshold: 0.35 });
    var vids = document.querySelectorAll('video[data-mm-autoplay]');
    for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
  }
  document.addEventListener('DOMContentLoaded', observeVideos);
  document.addEventListener('shopify:section:load', observeVideos);
})();
